import type { ICellValue, ITextField } from '../types'

import z from 'zod'

import { BasicValueType, FOperator, FOperatorDescMap } from '../types'
import { Field } from './field'

export type ICommonTextField = ITextField

export abstract class TextBaseField extends Field {
	static readonly _acceptFilterOperators = [
		FOperator.Is,
		FOperator.IsNot,
		FOperator.Contains,
		FOperator.NotContains,
		FOperator.IsEmpty,
		FOperator.IsNotEmpty,
		FOperator.In,
	]

	static readonly cellValueSchema = z.string().nullable()

	static readonly openWriteValueSchema = z.string().nullable()

	static readonly propertySchema = z.null()

	validateCellValue(cv: ICellValue) {
		return TextBaseField.cellValueSchema.safeParse(cv)
	}

	validateOpenWriteValue(owv: string | null) {
		return TextBaseField.openWriteValueSchema.safeParse(owv)
	}

	get openValueSchema() {
		return z.string().nullable()
	}

	override showFOperatorDesc(type: FOperator) {
		return FOperatorDescMap[type]
	}

	get acceptFilterOperators(): FOperator[] {
		return TextBaseField._acceptFilterOperators
	}

	get basicValueType() {
		return BasicValueType.String
	}

	cellValueToString(cellValue: string | null): string | null {
		if (cellValue == null) {
			return null
		}

		return cellValue
	}

	static stringInclude(str: string, searchStr: string) {
		return str.toLowerCase().includes(searchStr.trim().toLowerCase())
	}
}
